export default __webpack_public_path__ + "static/media/illustration-flowing-conversation.447b9b47.svg";